import React from 'react';

function partiallyApplyComponent<T>(
  Component: React.ComponentType<T>,
  partialProps: any
) {
  if (!(partialProps && Component)) {
    throw new Error(
      'partiallyApplyComponent requires `partialProps` and `Component` arguments.'
    );
  }

  const PartiallyApplied = (props: any) => (
    <Component {...partialProps} {...props} />
  );

  PartiallyApplied.displayName = `PartiallyApplied${Component.displayName ||
    Component.name}`;
  return PartiallyApplied;
}

export default partiallyApplyComponent;
